import mixin from './mixin'
import conversionData from '@/data/kuaishou/conversion_type.json'
import cityData from '@/data/kuaishou/city_province.json'
import weektimeData from '@/data/kuaishou/weektime_data'
import { marks, androidVersion, iOSVersion, iosDeviceBrand, deviceBrand, devicePrice, filterConvertLevel } from '@/data/kuaishou/datas'
import {
  isArray,
  getTime,
  formatDate,
  clearTagOfData,
  getNameOfData,
  getKeyOfData,
  findCheck,
  splicing,
  deepCopy,
  pullKeys,
  isEmpty
} from '@/common/js/utils'
import {
  getCampaign,
  getAppList,
  getPopulationList,
  getTargetingTags,
  getAppSearch,
  createPlan,
  updatePlan,
  queryByAdIdAndMediaId,
  ksCreative,
  getMagneticPage,
  getAllPagesByAccount
} from '@/api/kuaishou.model'
import { getCaoHuaGames, getCaoHuaAgent } from '@/api/common.model'

// import SelectButler from '@/components/select/select-butler.vue'
import Selecter from '@/components/select/selecter.vue'
import Version from '@/components/version/'
import Retarget from './components/retarget'
import DragWeektime from '@/components/drag/drag-weektime.vue'
import Adder from '@/components/add/adder'
import resulter from './components/convert/resulter.vue'
import ActionInterest from '@/views/create/kuaishou_local/components/actioninterest/'

const now = formatDate(new Date(), 'yyyy-MM-dd')

const commonKeys = [
  'ad_account_id',
  'bitch_add_begin',
  'bitch_add_end',
  'campaign_id',
  'plan_name',
  'ch_platform_id',
  'game_id',
  'proxy_account_id',
  'package',
  'use_sdk',
  'app_privacy_url',
  'landing_type',
  'monitor_template_id',
  'callbackSwitch',
  'callbackSettings'
]

const kuaishouKeys = [
  'app_id',
  'package_id',
  'app_name',
  'day_budget',
  'speed',
  'show_mode',
  'begin_time',
  'end_time',
  'schedule_time',
  'ocpx_action_type',
  'bid_type',
  'cpa_bid',
  'deep_conversion_type',
  'deep_conversion_bid',
  'scene_id',
  'roi_ratio',
  'quick_search',
  'target_explore',
  'extend_search',
  'unit_material_type'
]

const exclude_targetKeys = ['app_interest_ids', 'app_ids', 'filter_converted_level']

const targetKeys = [
  'region',
  // 'age',
  'age_v2',
  'gender',
  'platform_os',
  'android_osv',
  'ios_osv',
  'device_brand_ids',
  'device_price',
  'network',
  'behavior_type',
  'behavior_interest',
  'population',
  'exclude_population',
  'paid_audience'
]

export default {
  name: 'plan',
  mixins: [mixin],
  components: { Selecter, Version, Retarget, DragWeektime, Adder, resulter, ActionInterest },
  computed: {
    editState() {
      return this.$router.currentRoute.query.t === 'edit'
    },
    noSpeedEdit() {
      return this.editState && this.plan.deep_conversion_type !== 0
    },
    platformGameData() {
      return this.gameData.filter((ret) => ret.ch_platform_id === this.plan.ch_platform_id)
    },
    isAndroid() {
      return this.plan.ch_platform_id === 1
    },
    isMiniGame() {
      return this.plan.ch_platform_id === 3
    },
    isUseAdUnion() {
      return this.plan.scene_id === 5
    },
    conversionList() {
      if (this.plan.ocpx_action_type === 190) {
        return this.conversionData.filter((ret) => ret.id !== 3)
      }
      return this.conversionData
    },
    deepConversion() {
      return [180, 190].includes(this.plan.ocpx_action_type)
    },
    isROI() {
      return [191, 774].includes(this.plan.ocpx_action_type)
    },
    startOption() {
      return (date) => {
        return date && (date.valueOf() < Date.now() - 86400000 || date.valueOf() > getTime(this.plan.end_time))
      }
    },
    endOption() {
      return (date) => {
        return date && date.valueOf() < getTime(this.plan.begin_time)
      }
    },
    mult_city() {
      return findCheck(this.cityData)
    },
    mult_app() {
      return findCheck(this.appData)
    },
    mult_timeRange() {
      const arr = []
      this.weektimeData.forEach((item) => {
        arr.push({
          id: item.row,
          week: item.value,
          value: splicing(item.child)
        })
      })
      return arr
    },
    deviceBrand() {
      if (this.plan.platform_os === 0) {
        return [...iosDeviceBrand, ...deviceBrand]
      }
      if (this.plan.platform_os === 1) {
        return deviceBrand
      }
      if (this.plan.platform_os === 2) {
        return iosDeviceBrand
      }
      return []
    },
    minCbid() {
      const bid = this.plan.cpa_bid
      return bid > 0 && bid < 10000 ? bid : 1
    },
    maxCbid() {
      const budget = this.plan.day_budget
      return budget > 0 && budget < 10000 ? budget : 10000
    },
    isLink() {
      return this.plan.landing_type === 'LINK'
    },
    page_type_custom() {
      return this.plan.web_uri_type && this.plan.web_uri_type === 2 ? 1 : 2
    }
  },
  watch: {
    isAndroid(val) {
      // iOS游戏自动开启回调开关并禁止关闭
      // const callbackSettings = ['callbackTypeActive', 'callbackTypeRegist', 'callbackTypeRecharge', 'callbackTypeMoney']
      this.$set(this.plan, 'callbackSwitch', !val ? 1 : 0)
      // !val && this.$set(this.plan, 'callbackSettings', callbackSettings)
      this.$set(this.plan, 'use_sdk', val ? 1 : 0)
    },
    isUseAdUnion() {
      this.$set(this.plan, 'intelli_extend_option', 0)
      this.$set(this.plan, 'speed', 1)
      this.$set(this, 'app_behavior', 0)
      this.$set(this, 'filter_converted_level', 0)
    },
    'plan.intelli_extend_option': {
      handler(val) {
        if (val) {
          this.audienceData.forEach((item) => {
            item.select === 'include' && this.$set(item, 'select', null)
          })
        }
      }
    },
    weektimeData: {
      handler(nVal) {
        if (isArray(nVal)) {
          this.plan.schedule_time = nVal
            .map((item) => {
              return item.child.map((ret) => (ret.check ? '1' : '0')).join('')
            })
            .join('')
        }
      },
      deep: true
    }
  },
  data() {
    return {
      batch: null, // 是否批量建立
      cating: null, // 加载app名称
      conversion: false,
      hasCreative: false,
      gameData: [], // 常用游戏数据源
      agentData: [], // 人员数据源
      appiOSList: [],
      appAndList: [],
      landPageList: [],
      district: 'NONE',
      cityData, // 定向地域数据源
      marks, // 年龄标志
      ageMode: 'NONE',
      audienceMode: 'NONE',
      audienceData: [], // 人群包数据源
      payTypeBag: [7],
      conversionData,
      androidVersion,
      iOSVersion,
      // deviceBrand,
      devicePrice,
      app_behavior: 0,
      appData: [],
      categroyData: [], // APP分类
      mult_cate: [], // 选择的app名称
      filterConvertLevel,
      weektimeData,
      bidType: null, // 第一层级投放场景
      magneticPageData: [],
      resulteColumns: [
        {
          key: 'campaign_name',
          title: '快手推广计划'
        },
        {
          key: 'plan_name',
          title: '计划组名称'
        },
        {
          key: 'inner_status',
          title: '内部计划'
        },
        {
          key: 'outer_status',
          title: '快手计划组'
        },
        {
          key: 'msg',
          title: '原因'
        }
      ],
      budget: 'NONE', // 预算模式默认不限,
      dateRange: 'NONE', // 投放时间
      timeRange: 'NONE',
      campaign_id: this.$route.params.id,
      plan: {
        // 基础信息
        campaign_ids: [], // 批量广告组
        campaign_name: '',
        ad_id: this.$route.query.ad, // 计划ID
        plan_name: '', // 广告计划名称
        ch_platform_id: 1, // 游戏类型
        agent: 'NOAGENT', // 是否代投
        game_id: '',
        proxy_account_id: undefined,
        landing_type: 'APP', // 投放方式—直接下载
        callbackSwitch: 0, // 回调开关，默认关闭
        callbackSettings: ['callbackTypeActive'], // 回调类型
        monitorPlan: [], // 计划管家
        bitch_add_begin: undefined, // 批量起始
        bitch_add_end: undefined,
        monitor_template_id: undefined,
        // monitorPlan: '', // 自动化规则

        // 投放目标
        scene_id: 1, // 场景Id
        app_type: 'android',
        app_name: '',
        app_icon: '',
        package: '', // 游戏包名
        download_url: '',
        use_sdk: 1, // 是否接入快手SDK
        site_type: 1,

        // 搜索快投
        quick_search: 0,
        target_explore: 0,

        // 定向
        intelli_extend_option: 0, // 是否开启智能定向
        gender: 0, // 性别默认不限
        region: [], // 地域ID列表
        age: [25, 45], // 年龄
        platform_os: 0,
        android_osv: 3, // 安卓版本
        ios_osv: 6, // iOS版本
        device_brand_ids: 0, // 设备品牌
        device_price: 0, // 设备价格
        network: 0, // 网络
        app_interest_ids: [], // APP行为-按分类
        app_ids: [], // APP行为-按应用
        filter_converted_level: 0, // 过滤已转化
        exclude_population: [], // 定向人群包
        population: [], // 排除人群包
        behavior_type: 0, // 行为兴趣定向
        action_tags: [],
        word_tags: [],
        action_scene: [1, 2, 4],
        action_days: 4,
        action_intensity: 0,
        interest_intensity: 0,

        // 预算与出价
        day_budget: 0, // 预算值
        speed: 1, // 投放方式
        begin_time: now,
        end_time: now,
        show_mode: 2, // 创意展现方式
        ocpx_action_type: 2, // 优化目标
        bid_type: 10, // 计费类型
        cpa_bid: '', // 目标转化出价
        deep_conversion_type: 0, // 深度转化目标
        deep_conversion_bid: '', // 深度优化目标出价
        roi_ratio: '' // ROI系数
      }
    }
  },
  methods: {
    getData() {
      const params = {
        ad_account_id: this.account,
        ad_id: this.plan.ad_id
      }
      const delNullValue = (data) => {
        Object.keys(data).forEach((key) => {
          if (typeof data[key] === 'undefined' || data[key] === null) {
            delete data[key]
          }
        })
      }
      Promise.all([queryByAdIdAndMediaId(params), ksCreative(params)]).then((data) => {
        if (data) {
          const [adPlanInfo, hasCreative] = data
          const { plan_info, out_plan_info } = adPlanInfo
          if (plan_info) {
            delNullValue(plan_info)
            const {
              plan_name,
              ch_platform_id,
              game_id,
              proxy_account_id,
              landing_type,
              callbackSwitch,
              callbackSettings,
              monitor_template_id,
              monitor_template_name,
              land_page_id,
              page_addr
            } = plan_info
            Object.assign(this.plan, {
              plan_name,
              ch_platform_id,
              game_id,
              proxy_account_id,
              landing_type,
              agent: proxy_account_id ? 'AGENT' : 'NOAGENT',
              callbackSwitch: callbackSwitch,
              callbackSettings: callbackSettings || ['callbackTypeActive'],
              monitor_template_id: monitor_template_id || '',
              land_page_id,
              page_addr,
              monitorPlan: monitor_template_id ? [{ id: monitor_template_id, ruleName: monitor_template_name }] : []
            })

            // 选择游戏
            const gameNode = this.gameData.filter((ret) => ret.id === game_id).pop()
            if (gameNode) this.handleGame(gameNode)
          }
          if (out_plan_info) {
            const { app_id, begin_time, end_time, schedule, schedule_time, day_budget, scene_id, deep_conversion_type, target, site_type } =
              out_plan_info

            if (target) {
              const {
                region,
                age,
                age_v2,
                app_interest_ids,
                app_ids,
                population,
                device_brand_ids,
                device_price,
                exclude_population,
                paid_audience,
                behavior_interest,
                intelli_extend_option
              } = target

              delNullValue(target)
              delNullValue(out_plan_info)

              Object.assign(this.plan, target, out_plan_info, {
                intelli_extend_option: Number(intelli_extend_option),
                promoted_type: site_type ? 1 : 0
              }) // 原生参数合并

              if (this.plan.url) {
                getMagneticPage({
                  ad_account_id: this.account,
                  page_type: this.pageType ? 1 : 2
                })
                  .then((data) => {
                    this.magneticPageData = data
                  })
                  .catch((err) => console.log(err))
              }
              const ageV2 = age_v2 || age
              this.ageMode = age && Object.keys(age).length > 0 ? 'CUSTOM' : 'NONE'
              if (this.ageMode === 'CUSTOM') {
                const min = ageV2.min
                const max = ageV2.max === 100 ? 75 : ageV2.max
                this.plan.age = [min, max]
              }
              this.district = region && region.length ? 'CITY' : 'NONE'

              this.audienceMode = population?.length || exclude_population?.length || paid_audience?.length ? 'AUDIENCE' : 'NONE'
              if (this.district === 'CITY') this.decompile(region, this.cityData)
              if (!device_brand_ids?.length) this.plan.device_brand_ids = 0
              if (!device_price?.length) this.plan.device_price = 0
              // app行为
              if (isArray(app_interest_ids) && app_interest_ids.length) {
                this.app_behavior = 1
                this.decompile(app_interest_ids, this.appData)
              } else if (isArray(app_ids) && app_ids.length) {
                this.app_behavior = 2
                this.mult_cate = app_ids.map((ret) => {
                  return {
                    id: ret,
                    name: ret
                  }
                })
              }
              // 人群包
              if (this.audienceMode === 'AUDIENCE') {
                if (isArray(population)) {
                  population.forEach((ret) => {
                    const item = getKeyOfData(this.audienceData, 'id', ret)
                    this.$set(item, 'select', 'include')
                  })
                }
                if (isArray(paid_audience)) {
                  paid_audience.forEach((ret) => {
                    const item = getKeyOfData(this.audienceData, 'id', ret)
                    this.$set(item, 'select', 'include')
                  })
                }
                if (isArray(exclude_population)) {
                  exclude_population.forEach((ret) => {
                    const item = getKeyOfData(this.audienceData, 'id', ret)
                    this.$set(item, 'select', 'exclude')
                  })
                }
              }
              // 行为兴趣
              const { behavior, interest } = behavior_interest || {}
              if (behavior || interest) this.plan.behavior_type = 1
              if (behavior) {
                const { keyword, label, time_type, strength_type, scene_type } = behavior
                if (isArray(keyword) && keyword.length) {
                  this.plan.action_tags.push(
                    ...keyword.map((ret) => {
                      return {
                        id: ret.id,
                        name: ret.name,
                        num: '未知',
                        type: 'KEYWORD'
                      }
                    })
                  )
                }
                if (isArray(label) && label.length) {
                  this.plan.action_tags.push(
                    ...label.map((ret) => {
                      return {
                        id: ret,
                        name: ret,
                        type: 'CATEGORY'
                      }
                    })
                  )
                }
                this.plan.action_days = time_type
                this.plan.action_intensity = strength_type
                this.plan.action_scene = scene_type
              }
              if (interest) {
                const { label, strength_type } = interest
                if (isArray(label) && label.length) {
                  this.plan.word_tags.push(
                    ...label.map((ret) => {
                      return {
                        id: ret,
                        name: ret,
                        type: 'CATEGORY'
                      }
                    })
                  )
                }
                this.plan.interest_intensity = strength_type
              }

              this.budget = day_budget ? 'BUDGET' : 'NONE'
              this.dateRange = end_time ? 'RANGE' : 'NONE'
              const beginTime = formatDate(new Date(begin_time), 'yyyy-MM-dd')
              const endTime = formatDate(new Date(end_time), 'yyyy-MM-dd')
              if (beginTime < now) {
                this.plan.begin_time = now
              } else this.begin_time = beginTime
              this.timeRange = schedule ? 'RANGE' : 'NONE'
              this.reverWeektime(schedule_time)
              // scene 场景id
              this.plan.scene_id = scene_id.some((ret) => [6, 7, 10, 24].includes(ret)) ? scene_id : scene_id[0]
              if (scene_id.includes(1)) this.plan.scene_id = 1

              if (this.dateRange === 'RANGE') {
                if (endTime < now) {
                  this.plan.end_time = now
                } else this.plan.end_time = endTime
              }

              // 编辑 | iOS绑定应用
              if (this.editState || !this.isAndroid) this.plan.app_type = app_id
              // 深度转化类型绑定
              if (deep_conversion_type === 3) this.conversion = true
              else this.plan.deep_conversion_bid = undefined
              this.hasCreative = hasCreative
            } else this.$Message.error('没有生成外部计划')
          }

          this.show = true
          this.$Spin.hide()
        }
      })
      // .catch(err => {
      //   this.$Message.error(err)
      //   this.show = true
      //   this.$Spin.hide()
      // })
    },
    preloadData() {
      this.accounts = [{ id: this.account }]
      // 查推广计划详细
      const param = {
        ad_account_id: this.account,
        id: this.plan.campaign_ids[0]
      }
      // 请求开始
      this.show = false
      this.$Spin.show()
      Promise.all([
        getCaoHuaGames(),
        getCaoHuaAgent(),
        getCampaign(param),
        getAppList({ ad_account_id: this.account }),
        getPopulationList({ ad_account_id: this.account }),
        getTargetingTags({ ad_account_id: this.account, type: 'APP_INTEREST_ID' }),
        getAllPagesByAccount({ ad_account_id: this.account })
      ])
        .then((data) => {
          const [gameData, agentData, campaignData, appData, audienceData, appInterest, allPages] = data

          isArray(allPages) && (this.landPageList = allPages)

          isArray(gameData) && (this.gameData = gameData)
          isArray(agentData) && (this.agentData = agentData)
          if (isArray(audienceData)) {
            this.audienceData = audienceData.map((ret) => {
              return {
                id: ret.orientation_id,
                key: ret.orientation_id,
                vaule: ret.orientation_name,
                name: ret.orientation_name,
                extend: ret.cover_num,
                type: ret.population_type,
                code: ret.third_platform_code
              }
            })
          }
          if (campaignData) {
            const { campaign_name, bid_type } = campaignData
            this.plan.campaign_name = campaign_name
            this.bidType = bid_type
            !this.editState && (this.plan.plan_name = campaign_name)
          }
          if (isArray(appData) && appData.length) {
            this.appiOSList = appData.filter((ret) => ret.platform === 'ios')
            this.appAndList = appData.filter((ret) => ret.platform === 1)
          }

          this.appData = isArray(appInterest) ? appInterest.map((app) => ({ ...app, value: app.name })) : []

          if (this.plan.ad_id) this.getData()
          else {
            this.show = true
            this.$Spin.hide()
          }
        })
        .catch((e) => {
          this.show = true
          this.$Spin.hide()
          throw new Error('请求接口错误')
        })
    },
    platformChange() {
      this.plan.game_id = ''
      this.plan.app_id = ''
      this.plan.app_icon = ''
      this.plan.package = ''
      this.plan.download_url = '' // 包下载地址
      // 安卓游戏名称填入应用名称
      if (this.isAndroid) this.$set(this.plan, 'app_name', '')
    },
    handleGame(meta) {
      this.plan.game_id = meta.id
      this.plan.app_icon = meta.icon
      this.plan.package = meta.ad_package // 更改成显示包名
      this.plan.download_url = meta.game_address // 包下载地址
      // 安卓游戏名称填入应用名称
      if (this.isAndroid) this.$set(this.plan, 'app_name', meta.name)
    },
    // 代投账号
    changeAgent(val) {
      if (val === 'AGENT') this.plan.proxy_account_id = ''
      else this.plan.proxy_account_id = undefined
    },
    // 选择代投账号
    handleAgent(meta) {
      this.plan.proxy_account_id = meta.id
    },
    // 选择计划管家回调
    appendButler(val) {
      this.plan.monitorPlan = val
    },
    setDays(val) {
      this.plan.action_days = val
    },
    setScene(val) {
      this.plan.action_scene = val
    },
    setIntensity(prop, val) {
      this.plan[prop] = val
    },
    // 批量开关
    changeBatch(val) {
      if (val) {
        this.plan.bitch_add_begin = ''
        this.plan.bitch_add_end = ''
      } else {
        this.plan.bitch_add_begin = undefined
        this.plan.bitch_add_end = undefined
      }
    },
    changeConversion() {
      if (this.isROI) this.plan.cpa_bid = 0
      else this.plan.roi_ratio = undefined
      if (!this.deepConversion) {
        this.plan.deep_conversion_type = 0
        this.plan.deep_conversion_bid = undefined
        this.conversion = false
      }
    },
    changeiOSApp(id) {
      const matchApp = this.appiOSList.filter((ret) => ret.app_id === id)
      if (!matchApp.length) return
      const { app_name } = matchApp.pop()
      this.plan.app_name = app_name
    },
    // 投放时间
    changeStartTime(val) {
      const start = getTime(val)
      const end = getTime(this.plan.end_time)
      if (end < start) this.plan.end_time = val
      this.plan.begin_time = val
    },
    changeEndTime(val) {
      this.plan.end_time = val
    },
    changeDeepConver(val) {
      this.conversion = val === 3
      if (val === 3) {
        this.plan.deep_conversion_bid = ''
      } else {
        this.plan.deep_conversion_bid = undefined
      }
    },
    changeBudget(val) {
      if (val === 'BUDGET') this.plan.day_budget = ''
      else this.plan.day_budget = 0
    },
    radioChange(key) {
      clearTagOfData(this[key], this)
    },
    decompile(Ids, data) {
      const deepSelect = (item) => {
        item.forEach((ret) => {
          if (ret && ret.children && ret.children.length) deepSelect(ret.children)
          this.$set(ret, 'check', true)
        })
      }
      if (isArray(Ids) && Ids.length) {
        Ids.forEach((ret) => {
          const item = getKeyOfData(data, 'id', ret)
          deepSelect([item])
        })
      }
    },
    // 全选
    selectAll({ list, check = true, current = '' }) {
      let data
      if (current) {
        const item = getNameOfData(list, current)
        data = item.children
      } else data = list
      // 递归选中
      const deepSelectAll = (items) => {
        items.some((ret) => {
          if (ret.children && ret.children.length) deepSelectAll(ret.children)
          this.$set(ret, 'check', check)
        })
      }
      deepSelectAll(data)
    },
    // 删除已选
    delTag({ list, name }) {
      const data = getNameOfData(list, name)
      if (data.children && data.children.length) {
        this.selectAll({ list, check: false, current: data.value })
      } else {
        this.$set(data, 'check', false)
      }
    },
    // 清空全部
    clearTag({ list }) {
      clearTagOfData(list, this)
    },
    // 清空行为兴趣定向
    resetInterestAction() {
      this.plan.action_scene = [1, 2, 4]
      this.plan.action_days = 4
      this.plan.action_intensity = 0
      this.plan.interest_intensity = 0
      this.plan.action_tags = []
      this.plan.word_tags = []
    },
    // 清空人群包
    clearRetarget({ list }) {
      list.forEach((item) => {
        this.$set(item, 'select', null)
      })
    },
    delRetarget({ list, name }) {
      const index = list.findIndex((ret) => ret.name === name)
      if (index > -1) {
        this.$set(list[index], 'select', null)
      }
    },
    // 定向人群切换
    changeRetarget(val) {
      if (val === 'NONE') {
        this.audienceData.forEach((ret) => {
          this.$set(ret, 'select', '')
        })
      }
    },
    getCategroy(keyword) {
      const params = { ad_account_id: this.account, appName: keyword }
      this.cating = true
      getAppSearch(params).then((data) => {
        this.cating = false
        if (data) {
          this.categroyData = data.map((ret) => {
            return {
              id: ret.app_id,
              name: ret.app_name
            }
          })
        }
      })
    },
    changeBehavior() {
      this.radioChange('appData')
      this.categroyData = []
      this.mult_cate = []
    },
    selectCategroy(val) {
      const app_ids = this.categroyData.map((ret) => ret.id)
      const noSourceItem = this.mult_cate.filter((ret) => !app_ids.includes(ret.id))
      noSourceItem.push(...val)
      this.mult_cate = noSourceItem
    },
    delCategroy(ids) {
      if (isArray(ids)) {
        ids.forEach((met) => {
          const index = this.mult_cate.findIndex((ret) => ret.id === met)
          if (index > -1) {
            this.mult_cate.splice(index, 1)
          }
        })
      }
    },
    clearCategroy() {
      this.mult_cate = []
    },
    // 清空时间段
    clearWeektime() {
      this.weektimeData.forEach((item) => {
        item.child.forEach((t) => {
          this.$set(t, 'check', false)
        })
      })
    },
    reverWeektime(schedule) {
      let idx = 0
      for (let i = 0; i < this.weektimeData.length; i++) {
        const children = this.weektimeData[i].child
        for (let j = 0; j < children.length; j++) {
          const n = schedule.substr(idx, 1)
          this.$set(this.weektimeData[i].child[j], 'check', Boolean(parseInt(n)))
          idx++
        }
      }
    },
    valid() {
      const rules = [
        {
          name: 'plan/plan_name',
          require: true,
          min: 3,
          max: 80,
          desc: '计划名称'
        },
        {
          name: 'plan/game_id',
          require: true,
          min: 1,
          desc: '投放游戏'
        },
        {
          name: 'plan/proxy_account_id',
          require: true,
          relyon: 'agent',
          relyvalue: 'AGENT',
          min: 1,
          desc: '代投账号'
        },
        {
          name: 'plan/bitch_add_begin',
          require: true,
          relyon: 'batch',
          relyvalue: true,
          min: 1,
          desc: '批量起始数'
        },
        {
          name: 'plan/bitch_add_end',
          require: true,
          relyon: 'batch',
          relyvalue: true,
          min: 1,
          desc: '批量结尾数'
        },
        {
          name: 'plan/app_name',
          require: true,
          relyon: 'isAndroid',
          relyvalue: true,
          min: 1,
          desc: '游戏名'
        },
        {
          name: 'plan/day_budget',
          require: true,
          relyon: 'budget',
          relyvalue: 'BUDGET',
          min: 100,
          max: 100000000,
          desc: '预算'
        },
        {
          name: 'plan/deep_conversion_bid',
          require: true,
          relyon: 'conversion',
          relyvalue: true,
          min: this.minCbid,
          max: this.maxCbid,
          desc: '深度转化目标出价'
        },
        {
          name: 'plan/schedule_time',
          require: true,
          relyon: 'timeRange',
          relyvalue: 'RANGE',
          desc: '投放时段'
        },
        {
          name: 'plan/begin_time',
          require: true,
          relyon: 'dateRange',
          relyvalue: 'RANGE',
          desc: '开始日期'
        },
        {
          name: 'plan/end_time',
          require: true,
          relyon: 'dateRange',
          relyvalue: 'RANGE',
          desc: '结束日期'
        }
      ]
      this.formErr = false
      return this.invalid(rules)
    },
    submit(next) {
      const loading = next ? 'loading' : 'saving'
      const params = this.checkParams()

      // 验证模板
      if (!params) return
      params.commonParams.ad_id = this.plan.ad_id

      this[loading] = true
      updatePlan(params).then((data) => {
        this[loading] = false
        if (data) {
          this.ad_id = data.ad_id
          this.req_id = this.ad_id
          if (next) this.jump()
          else this.close()
        }
      })
    },
    submitToNext() {
      const params = this.checkParams()

      // 验证模板
      if (!params) return

      this.loading = true
      createPlan(params).then((data) => {
        this.loading = false
        this.retryState = false
        if (data && isArray(data.plan_info)) {
          const { plan_info } = data
          this.req_id = data.req_id
          this.retryState = data.retry
          // 批量
          if (isArray(plan_info) && plan_info.length) {
            this.model = true
            this.resData = plan_info.map((ret) => {
              ret.msg === '' && (ret.msg = '成功')
              return ret
            })
            this.ad_id = plan_info[0].ad_id
            this.plan_id = plan_info[0].plan_id
          }
        }
      })
    },
    checkParams() {
      let params = {
        ad_account_id: this.account,
        campaign_id: this.campaign_id
      }
      params = Object.assign({}, deepCopy(this.plan), params)
      this.errRes = this.valid() // 表单验证

      const { quick_search, target_explore } = params
      // 搜索快投
      if (quick_search) {
        params.target_explore = 1
        params.extend_search = true
        if (!target_explore) {
          params.target_explore = 0
        }
      } else {
        params.quick_search = 0
        params.target_explore = 0
        params.extend_search = false // 开启搜素快投须开启智能扩词，关闭搜素快投须关闭智能扩词
      }

      if (!this.isROI && !this.bidType) {
        const { cpa_bid, day_budget, bid_range, bid_num_range } = params
        const behaviorBid = this.plan.ocpx_action_type === 2 // 行为数出价限制
        const maxBid = behaviorBid ? 10 : 10000
        const minBid = behaviorBid ? 0.1 : 1
        if (bid_range) {
          // 随机出价
          const [min, max] = bid_num_range
          if (isEmpty(min) || isEmpty(max)) this.errRes.push({ feild: '目标转化出价', msg: '随机值不能为空' })
          else if (day_budget && Math.max(min, max) > day_budget) {
            this.errRes.push({ feild: '目标转化出价', msg: `随机值不能大于预算值 ${day_budget}` })
          }
        } else {
          if (isEmpty(cpa_bid)) this.errRes.push({ feild: '目标转化出价', msg: '目标转化出价不能为空' })
          else if (cpa_bid < minBid || cpa_bid > maxBid) {
            this.errRes.push({ feild: '目标转化出价', msg: `出价范围: ${minBid}~${maxBid} 元` })
          } else if (day_budget && cpa_bid && cpa_bid > day_budget) {
            this.errRes.push({ feild: '目标转化出价', msg: `出价不能大于预算值 ${day_budget}` })
          }
        }
      }

      if (this.isROI && !this.bidType) {
        const { roi_range, roi_ratio_range, roi_ratio } = params
        if (roi_range) {
          // 随机出价
          const [min, max] = roi_ratio_range
          if (isEmpty(min) || isEmpty(max)) this.errRes.push({ feild: 'ROI系数', msg: '随机值不能为空' })
        } else {
          if (isEmpty(roi_ratio)) this.errRes.push({ feild: 'ROI系数', msg: '系数不能为空' })
          else if (roi_ratio <= 0.001 || roi_ratio > 100) this.errRes.push({ feild: 'ROI系数', msg: '系数范围: 0.001 ~ 100' })
        }
      }

      if (this.isMiniGame) {
        params.unit_material_type = 4
      }

      if (!this.isAndroid && !this.isLink) {
        if (!this.plan.app_id) this.errRes.push({ feild: 'iOS应用', msg: 'iOS应用不能为空' })
      }

      if (this.errRes.length) {
        this.formErr = true
        return // 如果错误中断
      }

      if (this.dateRange !== 'RANGE') params.end_time = ''

      // 定向参数处理
      const getId = (ret) => ret.id
      if (this.district === 'CITY') {
        if (this.mult_city.length) params.region = this.mult_city.map(getId)
        else {
          this.$Message.error('指定区域未选择，应选择不限')
          return
        }
      }
      if (this.ageMode === 'CUSTOM') {
        let [min, max] = params.age
        // 不传值表示不限; 年龄区间min最小为 18 岁，需要满足 max - min >= 5且 18 <= min <= 75, 若71 <= min <= 75, 则max需传入100；年龄区间max最大为 100 岁；与 ages_range_v2 不能同时传。
        if (min >= 71 && min <= 75) max = 100
        params.age_v2 = { min: min, max: max }
      } else params.age_v2 = null
      if (!params.device_brand_ids) params.device_brand_ids = []
      if (!params.device_price) params.device_price = []
      if (params.intelli_extend_option !== 1) {
        if (this.app_behavior === 1) {
          params.app_interest_ids = this.mult_app.map((ret) => ret.ids || ret.id).flat(1)
          params.app_ids = []
        } else if (this.app_behavior === 2) {
          params.app_ids = this.mult_cate.map(getId)
          params.app_interest_ids = []
        } else {
          params.app_interest_ids = []
          params.app_ids = []
        }
        // 行为兴趣定向
        if (params.behavior_type === 1) {
          const keyword = params.action_tags
            .filter((ret) => ret.type === 'KEYWORD')
            .map((ret) => {
              return {
                id: ret.id,
                name: ret.name
              }
            })
          const action_label = params.action_tags.filter((ret) => ret.type === 'CATEGORY').map((ret) => ret.id)
          const interest_label = params.word_tags.filter((ret) => ret.type === 'CATEGORY').map((ret) => ret.id)
          if (!keyword.length && !action_label.length && !interest_label.length) {
            this.$Message.error('行为定向和意向定向需至少选择一种')
            return
          }
          params.behavior_interest = {
            behavior: {
              keyword: keyword,
              label: action_label,
              time_type: params.action_days,
              strength_type: params.action_intensity,
              scene_type: params.action_scene
            }
          }

          if (interest_label.length) {
            params.behavior_interest.interest = {
              label: interest_label,
              strength_type: params.interest_intensity
            }
          }
        }

        if (params.behavior_type === 0) {
          delete params.behavior_interest
        }
      }

      // 人群包提交
      const includes = this.audienceData.filter((ret) => ret.select === 'include')
      const excludes = this.audienceData.filter((ret) => ret.select === 'exclude')
      if (this.audienceMode === 'AUDIENCE' && !includes.length && !excludes.length) {
        this.$Message.error('请选择人群包，或是切换成不限')
      }
      if (this.audienceMode === 'AUDIENCE') {
        const payType = (type) => this.payTypeBag.includes(type)
        params.population = this.audienceData.filter((ret) => ret.select === 'include' && !payType(ret.type)).map((t) => t.id)
        params.exclude_population = this.audienceData.filter((ret) => ret.select === 'exclude' && !payType(ret.type)).map((t) => t.id)
        params.paid_audience = this.audienceData.filter((ret) => ret.select === 'include' && payType(ret.type)).map((t) => t.id)
      } else {
        params.population = null
        params.exclude_population = null
        params.paid_audience = undefined
      }
      if (params.platform_os === 1) delete params.ios_osv
      else if (params.platform_os === 2) {
        delete params.android_osv
        delete params.device_brand_ids
      }

      return this.wrapParams(params)
    },
    wrapParams(params) {
      const commonParams = pullKeys(commonKeys, params)
      const kuaishouParams = pullKeys(kuaishouKeys, params)
      let targetParams = deepCopy(targetKeys)

      // 不是联盟广告时可以使用
      if (!this.isUseAdUnion) {
        targetParams.push(...exclude_targetKeys)
        if (params.intelli_extend_option === 1) {
          // 不是联盟，是智能定向
          targetParams = [
            'region',
            'age',
            'age_v2',
            'gender',
            'android_osv',
            'ios_osv',
            'platform_os',
            'population',
            'exclude_population',
            'paid_audience',
            'audiences',
            'filter_converted_level'
          ]
        }
      }

      const target = pullKeys(targetParams, params)
      kuaishouParams.intelli_extend_option = params.intelli_extend_option

      commonParams.campaign_id = this.plan.campaign_ids[0]
      kuaishouParams.scene_id = typeof kuaishouParams.scene_id === 'number' ? [kuaishouParams.scene_id] : kuaishouParams.scene_id
      kuaishouParams.target = target

      return {
        commonParams,
        kuaishouParams,
        req_id: this.req_id,
        retry: this.retryState
      }
    },
    jump() {
      if (this.ad_id && this.req_id) {
        this.$store.commit('Kuaishou/setCurrent', 'idea')
        this.$store.commit('Kuaishou/changeState', 'plan')
        this.$router.push({
          name: 'kuaishouidea',
          params: {
            id: this.campaign_id,
            ad: this.ad_id
          },
          query: {
            req: this.req_id,
            plan: this.plan_id
          }
        })
      } else {
        this.$Message.warning('计划未创建成功，无法跳转')
      }
    },
    close() {
      this.closePageForm()
    }
  },
  created() {
    if (this.$router.currentRoute.query.t !== 'edit') this.beforeHandler()
    this.$store.commit('Kuaishou/clearModulerLinks')
    // 批量广告组ids
    if (window.sessionStorage.getItem('campaigns')) {
      const sess = JSON.parse(window.sessionStorage.getItem('campaigns'))
      this.plan.campaign_ids = [...sess]
    } else {
      this.plan.campaign_ids = [this.$router.currentRoute.params.id]
    }
    // const campaigns = [this.$router.currentRoute.params.id]
    // this.$set(this.plan, 'campaign_ids', campaigns) // 批量广告组ids
    this.preloadData()
  },
  mounted() {
    this.toTop()
  }
}
